import React from 'react';
import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { alpha, styled } from '@mui/material/styles';

import { ThemeColor } from '../theme';
import { colors } from '../theme/tokens.colors';
import { uikitPalette } from '../theme/uikitPalette';

export interface UIKitCheckboxProps extends Omit<CheckboxProps, 'color'> {
  label?: React.ReactNode;
  color?: ThemeColor;
  colorVariant?: 'main' | 'light' | 'dark' | 'on';
}

const StyledCheckbox = styled(Checkbox, {
  shouldForwardProp: (prop) => prop !== 'mainColor',
})<{ mainColor: string }>(({ mainColor }) => ({
  // 💠 Unselected (enabled)
  color: mainColor,

  '&:hover': {
    backgroundColor: alpha(mainColor, 0.12),
  },

  // 💠 Focused
  '&.Mui-focusVisible': {
    backgroundColor: alpha(mainColor, 0.12),
  },

  // 💠 Selected
  '&.Mui-checked': {
    color: mainColor,
  },
  '&.Mui-checked:hover': {
    backgroundColor: alpha(mainColor, 0.12),
  },

  // 💠 Indeterminate
  '&.Mui-indeterminate': {
    color: mainColor,
  },
  '&.Mui-indeterminate:hover': {
    backgroundColor: alpha(mainColor, 0.12),
  },

  // 💠 Disabled
  '&.Mui-disabled': {
    color: colors.neutral[200],
  },
}));

export const UIKitCheckbox: React.FC<UIKitCheckboxProps> = ({
  label,
  color = 'primary',
  colorVariant = 'main',
  ...checkboxProps
}) => {
  const mainColor = uikitPalette[color][colorVariant];

  const checkbox = (
    <StyledCheckbox
      color="default" // 👈 nunca usar primary/secondary de MUI
      disableRipple
      mainColor={mainColor}
      {...checkboxProps}
    />
  );

  if (!label) {
    return checkbox;
  }

  return <FormControlLabel control={checkbox} label={label} />;
};
